import { useFetchItems } from 'pe-core-frontend';
import { IMPORTS } from '../graphql/queries/import';
/**
 * Custom hook for fetching and managing imports.
 *
 * @param {UseImportsProps} options - The options for the hook.
 * @param {string} options.clientId - The client ID.
 * @returns {Object} - The import items, error, and loading state.
 */
export const useImports = ({ clientId, id }) => {
    const { items, error, loading, refetch } = useFetchItems({
        fetchQuery: IMPORTS,
        dataProp: 'imports',
        spec: { clientId, id },
    });
    return {
        items,
        error,
        loading,
        refetch,
    };
};
